import { z } from "zod"
import { empty, pick, omit } from "@schtappe/utils"

import * as Definitions from "../models/definitions.js"
import * as Shared from "../models/shared.js"
import { formatters } from "../helpers/admin.js"

const { Integer, Decimal } = Definitions

const attributes = {
        id: { type: Integer, form: false },
        automated_via_sftp: { type: Boolean },
        sftp_host: { type: String, nullable: true },
        sftp_path: { type: String, nullable: true },
        sftp_username: { type: String, nullable: true },
        sftp_password: { type: String, nullable: true },
        pemfile: { type: File },
}

const Request = ({ helpers, config }) => ({
        Update: (data) => {
                if (data == Symbol.for("empty")) {
                        return helpers.createEmptyForm(pick(["key", "attributes"], config))
                }

                const form = z.object(helpers.modelToParser({
                        exclude: Object.entries(attributes).filter(([key, value]) => value.form === false).map(([key]) => key),
                        attributes: config.attributes,
                }))
                return z.object({ [config.key]: form }).safeParse(data)
        },
})

const Response = ({ helpers, config }) => ({
        Show: z.object({
                ...helpers.modelToParser({
                        exclude: ["pemfile"],
                        attributes: config.attributes,
                }),
                pemfile_url: z.string().nullable(),
                account_id: z.number(),
        }).safeParse,
})

const Form = ({ helpers, config }) => ({
        Update: helpers.generateFormFields({
                attributes: config.attributes,
        }),
})

const Api = ({ helpers, config }) => ({
        Show: {
                successParser: config.Response.Show,
        },
        Update: {
                bodyParser: (options = { form: {} }) => config.Request.Update({
                        [config.key]: options.form,
                }),
                errorParser: Shared.Response.Errors,
        },
})

const TableHeaders = [
]

const Pages = {
}

export default Shared.defineAdminModel({
        key: "campaign_setting",
        attributes,
        Request,
        Response,
        Form,
        Api,
        TableHeaders,
        Pages,
})
